import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {environment} from '../environments/environment';
import {HttpClientModule, HTTP_INTERCEPTORS, HttpClient} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ToastrModule} from 'ngx-toastr';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {AgmCoreModule, GoogleMapsAPIWrapper} from '@agm/core';
import {HighchartsChartModule} from 'highcharts-angular';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatButtonModule} from '@angular/material/button';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS} from '@angular/material/core';
import {MomentDateAdapter, MAT_MOMENT_DATE_FORMATS, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import {MatBadgeModule} from '@angular/material/badge';
import {MatCardModule} from '@angular/material/card';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatChipsModule} from '@angular/material/chips';
import {MatOptionModule, MatNativeDateModule} from '@angular/material/core';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatDialogModule} from '@angular/material/dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatIconModule} from '@angular/material/icon';
import {MatInputModule} from '@angular/material/input';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {MatRadioModule} from '@angular/material/radio';
import {MatSelectModule} from '@angular/material/select';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatSliderModule} from '@angular/material/slider';
import {MatSortModule} from '@angular/material/sort';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTableModule} from '@angular/material/table';
import {MatTabsModule} from '@angular/material/tabs';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatTreeModule} from '@angular/material/tree';
import {DragDropModule} from '@angular/cdk/drag-drop';
import {RouterModule, Routes} from '@angular/router';
import {AppComponent} from './app.component';
import {ProjectsComponent} from './routed/projects/projects.component';
import {NgbModule, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {LevelsComponent} from './routed/levels/levels.component';
import {UsersComponent} from './routed/users/users.component';
import {DevicesComponent} from './routed/devices/devices.component';
import {ProgressbarComponent} from './shared/components/progressbar/progressbar.component';
import {MyAcountComponent} from './routed/my-acount/my-acount.component';
import {LevelCrudComponent} from './routed/level/level-crud/level-crud.component';
import {UserCrudComponent} from './routed/user/user-crud/user-crud.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {ErrorInterceptor} from './shared/interceptors/error-interceptor';
import {BasicAuthInterceptor} from './shared/interceptors/basic-auth.interceptor';
import {MathsNaiveComponent} from './routed/projects-subscriptions/maths-naive/maths-naive.component';
import {DeviceCrudComponent} from './routed/device/device-crud/device-crud.component';
import {LoginComponent} from './routed/authentication/login/login.component';
import {AuthGuard} from './shared/guard/auth/auth.guard';
import {LevelGuard} from './shared/guard/level/level.guard';
import {OsmosUserGuard} from './shared/guard/osmos-user/osmos-user.guard';
import {PasswordForgotComponent} from './routed/authentication/password-forgot/password-forgot.component';
import {PasswordResetComponent} from './routed/authentication/password-reset/password-reset.component';
import {DeviceChildrenComponent} from './shared/components/device/device-children/device-children.component';
import {DeviceChildrenAvalaibleComponent} from './shared/components/device/device-children/modals/device-children-avalaible/device-children-avalaible.component';
import {ProjectCrudComponent} from './routed/project/project-crud/project-crud.component';
import {ProjectUserAddListComponent} from './routed/project/project-crud/steps/project-user/project-user-add-list/project-user-add-list.component';
import {ProjectUserRemoveListComponent} from './routed/project/project-crud/steps/project-user/project-user-remove-list/project-user-remove-list.component';
import {ProjectAddressComponent} from './routed/project/project-crud/steps/project-address/project-address.component';
import {ProjectInformationComponent} from './routed/project/project-crud/steps/project-information/project-information.component';
import {ProjectLocationComponent} from './routed/project/project-crud/steps/project-location/project-location.component';
import {ProjectDeviceComponent} from './routed/project/project-crud/steps/project-device/project-device.component';
import {ProjectDeviceLocationAddComponent} from './routed/project/project-crud/steps/project-location/modals/project-device-location-add/project-device-location-add.component';
import {ProjectDeviceAssignementComponent} from './routed/project/project-crud/steps/project-device/modals/project-device-assignement/project-device-assignement.component';
import {DeviceConfigurationDownloadComponent} from './shared/components/device/device-configuration-download/device-configuration-download.component';
import {SchedulerSpcuComponent} from './shared/components/scheduler-spcu/scheduler-spcu.component';
import {ProjectExportCsvComponent} from './routed/project/project-export-csv/project-export-csv.component';
import {ProjectMeasureGraphicComponent} from './routed/project/project-measure-graphic/project-measure-graphic.component';
import {LirisV2Component} from './routed/device/device-crud/forms-params/liris-v2/liris-v2.component';
import {InclinoV2Component} from './routed/device/device-crud/forms-params/inclino-v2/inclino-v2.component';
import {LirisV3Component} from './routed/device/device-crud/forms-params/liris-v3/liris-v3.component';
import {InclinoV3Component} from './routed/device/device-crud/forms-params/inclino-v3/inclino-v3.component';
import {GatewayV3Component} from './routed/device/device-crud/forms-params/gateway-v3/gateway-v3.component';
import {ExtV5Component} from './routed/device/device-crud/forms-params/ext-v5/ext-v5.component';
import {OptV5Component} from './routed/device/device-crud/forms-params/opt-v5/opt-v5.component';
import {ExtensoV3Component} from './routed/device/device-crud/forms-params/extenso-v3/extenso-v3.component';
import {DauV5Component} from './routed/device/device-crud/forms-params/dau-v5/dau-v5.component';
import {ParamFilterComponent} from './routed/device/device-crud/forms-params/liris-v3/param-filter/param-filter.component';
import {ParamAxisInclinoComponent} from './routed/device/device-crud/forms-params/liris-v3/param-axis-inclino/param-axis-inclino.component';
import {ParamOtherComponent} from './routed/device/device-crud/forms-params/liris-v3/param-other/param-other.component';
import {ParamTriggerDataComponent} from './routed/device/device-crud/forms-params/liris-v3/param-trigger-data/param-trigger-data.component';
import {ParamCalibrationComponent} from './routed/device/device-crud/forms-params/liris-v3/param-calibration/param-calibration.component';
import {DeviceBatchActionComponent} from './shared/components/device/device-batch-action/device-batch-action.component';
import {UsersGuard} from './shared/guard/users/users.guard';
import {LocationTreeComponent} from './routed/project/project-measure-graphic/location-tree/location-tree.component';
import {UnknownRouteComponent} from './routed/unknown-route/unknown-route.component';
import {ParamOsmosLirisManagerComponent} from './routed/device/device-crud/forms-params/gateway-v3/param-osmos-liris-manager/param-osmos-liris-manager.component';
import {ParamServerComponent} from './routed/device/device-crud/forms-params/gateway-v3/param-server/param-server.component';
import {ParamCronComponent} from './routed/device/device-crud/forms-params/gateway-v3/param-cron/param-cron.component';
import {ParamNetworksComponent} from './routed/device/device-crud/forms-params/gateway-v3/param-networks/param-networks.component';
import {ParamMainComponent} from './routed/device/device-crud/forms-params/gateway-v3/param-main/param-main.component';
import {ProjectAlarmsComponent} from './routed/project/project-alarms/project-alarms.component';
import {ProjectAlarmsCrudComponent} from './routed/project/project-alarms-crud/project-alarms-crud.component';
import {ProjectAlarmsUserRemoveListComponent} from './routed/project/project-alarms-crud/steps/project-alarms-user/project-alarms-user-remove-list/project-alarms-user-remove-list.component';
import {ProjectAlarmsUserAddListComponent} from './routed/project/project-alarms-crud/steps/project-alarms-user/project-alarms-user-add-list/project-alarms-user-add-list.component';
import {ProjectAlarmsLocationRemoveListComponent} from './routed/project/project-alarms-crud/steps/project-alarms-location/project-alarms-location-remove-list/project-alarms-location-remove-list.component';
import {ProjectAlarmsLocationAddListComponent} from './routed/project/project-alarms-crud/steps/project-alarms-location/project-alarms-location-add-list/project-alarms-location-add-list.component';
import {DataProcessingMeasureComponent} from './shared/components/data-processing-measure/data-processing-measure.component';
import {ManualFrComponent} from './routed/manuals/manual-fr/manual-fr.component';
import {ManualEnComponent} from './routed/manuals/manual-en/manual-en.component';
import {ButtonProjectEditComponent} from './shared/components/button-project-edit/button-project-edit.component';
import {DeviceBatchImportComponent} from './routed/device/device-batch-import/device-batch-import.component';
import {DeviceBatchImportCsvLoaderComponent} from './routed/device/device-batch-import/device-batch-import-csv-loader/device-batch-import-csv-loader.component';
import {ProjectLastMeasureComponent} from './routed/project/project-last-measure/project-last-measure.component';
import {AlarmParametersFormStaticAmplitudeComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/alarm-parameters-forms/alarm-parameters-form-static-amplitude/alarm-parameters-form-static-amplitude.component';
import {ProjectAlarmParametersComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/project-alarm-parameters.component';
import {DefaultViewContainerRefDirective} from './shared/directives/default-view-container-ref.directive';
import {AlarmParametersFormStaticThresholdComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/alarm-parameters-forms/alarm-parameters-form-static-threshold/alarm-parameters-form-static-threshold.component';
import {AlarmParametersFormCombinationAlarmComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/alarm-parameters-forms/alarm-parameters-form-combination-alarm/alarm-parameters-form-combination-alarm.component';
import {CombinationAlarmExpressionElementComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/alarm-parameters-forms/alarm-parameters-form-combination-alarm/combination-alarm-expression-element/combination-alarm-expression-element.component';
import {InvalidValueErrorMessageComponent} from './routed/project/project-alarms-crud/steps/project-alarm-parameters/invalid-value-error-message/invalid-value-error-message.component';
import {VSensorComponent} from './routed/device/device-crud/forms-params/v-sensor/v-sensor.component';
import {VSensorLocationParamComponent} from './routed/device/device-crud/forms-params/v-sensor/v-sensor-location-param/v-sensor-location-param.component';
import {LocationAutocompleteInputComponent} from './routed/device/device-crud/forms-params/v-sensor/v-sensor-location-param/location-autocomplete-input/location-autocomplete-input.component';
import {UnitKeyModalComponent} from './routed/device/device-batch-import/device-batch-import-csv-loader/unit-key-modal/unit-key-modal.component';
import {GraphicalViewListComponent} from './shared/components/graphical-view-list/graphical-view-list.component';
import {DisableReactiveFormsDirective} from './shared/directives/disable-reactive-forms.directive';
import {ConvertLocationIdPipe} from './shared/pipes/convert-location-id/convert-location-id.pipe';
import {LocationAssignmentPreferencesToggleComponent} from './shared/components/location-assignment-preferences-toggle/location-assignment-preferences-toggle.component';
import {AdvancedDateSettingsComponent} from './shared/components/advanced-date-settings/advanced-date-settings.component';
import {ProjectsSubscriptionsComponent} from './routed/projects-subscriptions/projects-subscriptions.component';
import {SenceiveSubscriptionComponent} from './routed/projects-subscriptions/senceive-subscription/senceive-subscription.component';
import {ExportCsvTaskComponent} from './routed/export-csv-task/export-csv-task.component';
import {JobTaskStatusPipe} from './shared/pipes/job-task-status/job-task-status.pipe';
import {ExportCsvTaskModalComponent} from './routed/export-csv-task/export-csv-task-modal/export-csv-task-modal.component';
import {FileSizePipe} from './shared/pipes/file-size/file-size.pipe';
import {ButtonDownloadExportComponent} from './shared/components/button-download-export/button-download-export.component';
import {CsvSftpSubscriptionComponent} from './routed/projects-subscriptions/csv-sftp-subscription/csv-sftp-subscription.component';
import {SmartOffsetsModeComponent} from './routed/project/project-measure-graphic/smart-offsets-mode/smart-offsets-mode.component';
import {NewsteoSubscriptionComponent} from './routed/projects-subscriptions/newsteo-subscription/newsteo-subscription.component';
import {DeviceTypeSelectorComponent} from './shared/components/device/device-type-selector/device-type-selector.component';
import {DragDropLocationsModalComponent} from './shared/components/drag-drop-locations-modal/drag-drop-locations-modal.component';
import {DragDropAlertModalComponent} from './shared/components/drag-drop-locations-modal/drag-drop-alert-modal/drag-drop-alert-modal.component';
import {DeviceFinderComponent} from './routed/device/device-finder/device-finder.component';
import {WavesoftDeviceComponent} from './routed/device/device-crud/forms-params/wavesoft-device/wavesoft-device.component';
import {OffsetFormComponent} from './shared/components/data-processing-measure/offset-form/offset-form.component';
import {EraserFormComponent} from './shared/components/data-processing-measure/eraser-form/eraser-form.component';
import {ThresholdFormComponent} from './shared/components/data-processing-measure/threshold-form/threshold-form.component';
import {CustomGoogleMapsAPIWrapper} from './shared/services/google-map/customApiWrapper';
import {CustomClusterManager} from './shared/services/google-map/customClusterManager';
import {GridsterModule} from 'angular-gridster2';
import {WidgetProcessNamePipe} from './shared/pipes/widget-process-name/widget-process-name.pipe';
import {EventdynSubscriptionComponent} from './routed/projects-subscriptions/eventdyn-subscription/eventdyn-subscription.component';
import {SubscriptionsTypeResolver} from './shared/resolvers/subscriptions-type.resolver';
import {ParamChannelsExpeComponent} from './routed/device/device-crud/forms-params/liris-v3/param-channels-expe/param-channels-expe.component';
import {ClusterManager} from '@agm/markerclusterer';
import {ngfModule} from 'angular-file';
import {EventDynChartComponent} from './routed/project/project-measure-graphic-event-dyn/event-dyn-chart/event-dyn-chart.component';
import {EventDynHeaderFiltersComponent} from './routed/project/project-measure-graphic-event-dyn/event-dyn-header-filters/event-dyn-header-filters.component';
import {EventDynListTableComponent} from './routed/project/project-measure-graphic-event-dyn/event-dyn-list-table/event-dyn-list-table.component';
import {ProjectMeasureGraphicEventDynComponent} from './routed/project/project-measure-graphic-event-dyn/project-measure-graphic-event-dyn.component';
import {ProjectsAlarmsValidatorComponent} from './routed/projects-alarms-validator/projects-alarms-validator.component';
import {ProjectLastAlarmsComponent} from './routed/project/project-last-alarms/project-last-alarms.component';
import {ProjectEdasAlarmsComponent} from './routed/project/project-crud/project-edas-alarms/project-edas-alarms.component';
import {EdasAlarmsComponent} from './routed/project/project-crud/project-edas-alarms/edas-alarms/edas-alarms.component';
import {DashboardEdasComponent} from './routed/dashboard/dashboard-edas/dashboard-edas.component';
import {DashboardEdasDetailComponent} from './routed/dashboard/dashboard-edas/dashboard-edas-detail/dashboard-edas-detail.component';
import {ProjectNotationsComponent} from './routed/project/project-notations/project-notations.component';
import {NotationsModalComponent} from './routed/project/project-notations/notations-modal/notations-modal.component';
import {ProjectLocationMapComponent} from './routed/project/project-location-map/project-location-map.component';
import {ProjectLocationPlanComponent} from './routed/project/project-location-plan/project-location-plan.component';
import {UploadPlanComponent} from './routed/project/project-location-plan/upload-plan/upload-plan.component';
import {ProjectLocationMapPlanComponent} from './routed/project/project-location-map-plan/project-location-map-plan.component';
import {ProjectSubMenuComponent} from './routed/project/project-sub-menu/project-sub-menu.component';
import {ProjectViewListComponent} from './routed/project/project-view-list/project-view-list.component';
import {ProjectWimdComponent} from './routed/project/project-wimd/project-wimd.component';
import {AuthResolver} from './shared/resolvers/auth/auth.resolver';
import {WimdChartComponent} from './routed/project/project-wimd/wimd-chart/wimd-chart.component';
import {WimdTableComponent} from './routed/project/project-wimd/wimd-table/wimd-table.component';
import {WimdModalComponent} from './routed/project/project-wimd/wimd-modal/wimd-modal.component';
import {OsmosUserOrClientGuard} from './shared/guard/osmos-user-or-client/osmos-user-or-client.guard';

const appRoutes: Routes = [

  {path: 'maths', redirectTo: 'projects-specials-behaviors'},
  {path: 'maths/**', redirectTo: 'projects-specials-behaviors/:subscriptionType'},
  {path: 'manual-en', component: ManualEnComponent},
  {path: 'manual-fr', component: ManualFrComponent},
  {path: 'manual-jp', component: ManualEnComponent},
  {
    path: 'dashboard/edas', component: DashboardEdasComponent, canActivate: [AuthGuard, OsmosUserGuard]
  },
  {path: 'project-last-alarms/:idProject', component: ProjectLastAlarmsComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {path: 'project-alarms/:idProject', component: ProjectAlarmsComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'project-notations/:idProject', component: ProjectNotationsComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'project-wimd/:idProject', component: ProjectWimdComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {path: 'project-view-list/:idProject', component: ProjectViewListComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {
    path: 'project-locations-map-plan/:idProject',
    component: ProjectLocationMapPlanComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {path: 'project-locations-map/:idProject', component: ProjectLocationMapComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'project-locations-plan/:idProject', component: ProjectLocationPlanComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'project-last-measures/:idProject', component: ProjectLastMeasureComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {path: 'ctherm/:idProject', component: ProjectMeasureGraphicComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {
    path: 'ctherm/:idProject/:idLocation', component: ProjectMeasureGraphicComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'ctherm/:idProject/:idLocation/:dateStart/:dateEnd',
    component: ProjectMeasureGraphicComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {path: 'chart/:idProject', component: ProjectMeasureGraphicComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {
    path: 'chart/:idProject/:idLocation', component: ProjectMeasureGraphicComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'chart/:idProject/:idLocation/:dateStart/:dateEnd',
    component: ProjectMeasureGraphicComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'chart/:idProject/:idLocation/:dateStart/:dateEnd/dyn-tag',
    component: ProjectMeasureGraphicComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'chart/:idProject/:idLocation/:dateStart/:dateEnd/dyn-data',
    component: ProjectMeasureGraphicComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'chart/:idProject/:idLocation/:dateStart/:dateEnd/threshold/:thresholdValue',
    component: ProjectMeasureGraphicComponent,
    canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {
    path: 'projects-specials-behaviors',
    component: ProjectsSubscriptionsComponent,
    canActivate: [AuthGuard, OsmosUserGuard],
    resolve: {subscriptionTypes: SubscriptionsTypeResolver}
  },
  {
    path: 'projects-specials-behaviors/:subscriptionType',
    component: ProjectsSubscriptionsComponent,
    canActivate: [AuthGuard, OsmosUserGuard],
    resolve: {subscriptionTypes: SubscriptionsTypeResolver}
  },
  {path: 'event-dyn/:idProject', component: ProjectMeasureGraphicEventDynComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {path: 'projects-alarms-validator', component: ProjectsAlarmsValidatorComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'projects', component: ProjectsComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]},
  {path: 'projects/:idProject', component: ProjectCrudComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'projects/:idProject/:selectedStep', component: ProjectCrudComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'projects-view/:idProject', component: ProjectCrudComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {
    path: 'project-export-csv/:idProject', component: ProjectExportCsvComponent, canActivate: [AuthGuard, OsmosUserOrClientGuard]
  },
  {path: 'export-csv-tasks', component: ExportCsvTaskComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'project', component: ProjectCrudComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'levels', component: LevelsComponent, canActivate: [AuthGuard, LevelGuard, OsmosUserGuard]},
  {path: 'users', component: UsersComponent, canActivate: [AuthGuard, OsmosUserGuard, UsersGuard]},
  {path: 'devices', component: DevicesComponent, canActivate: [AuthGuard, OsmosUserGuard]},
  {path: 'my-account', component: MyAcountComponent, canActivate: [AuthGuard]},
  {path: '', component: UnknownRouteComponent, canActivate: [AuthGuard], resolve: [AuthResolver]},
  {path: 'password-forgot', component: PasswordForgotComponent},
  {path: 'password-reset', component: PasswordResetComponent},
  {path: 'login', component: LoginComponent},
  {path: '**', component: UnknownRouteComponent}
];

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    AppComponent,
    ProjectsComponent,
    LevelsComponent,
    UsersComponent,
    DevicesComponent,
    ProgressbarComponent,
    MyAcountComponent,
    LevelCrudComponent,
    UserCrudComponent,
    MathsNaiveComponent,
    DeviceCrudComponent,
    LoginComponent,
    PasswordForgotComponent,
    PasswordResetComponent,
    DeviceChildrenComponent,
    DeviceChildrenAvalaibleComponent,
    ProjectCrudComponent,
    ProjectUserAddListComponent,
    ProjectUserRemoveListComponent,
    ProjectAddressComponent,
    ProjectInformationComponent,
    ProjectLocationComponent,
    ProjectDeviceComponent,
    ProjectDeviceLocationAddComponent,
    ProjectDeviceAssignementComponent,
    DeviceConfigurationDownloadComponent,
    SchedulerSpcuComponent,
    ProjectExportCsvComponent,
    ProjectMeasureGraphicComponent,
    LirisV2Component,
    InclinoV2Component,
    LirisV3Component,
    InclinoV3Component,
    GatewayV3Component,
    ExtV5Component,
    OptV5Component,
    ExtensoV3Component,
    DauV5Component,
    ParamTriggerDataComponent,
    ParamCalibrationComponent,
    ParamFilterComponent,
    ParamAxisInclinoComponent,
    ParamOtherComponent,
    DeviceBatchActionComponent,
    LocationTreeComponent,
    UnknownRouteComponent,
    ParamOsmosLirisManagerComponent,
    ParamServerComponent,
    ParamCronComponent,
    ParamNetworksComponent,
    ParamMainComponent,
    ProjectAlarmsComponent,
    ProjectAlarmsCrudComponent,
    ProjectAlarmsUserRemoveListComponent,
    ProjectAlarmsUserAddListComponent,
    ProjectAlarmsLocationRemoveListComponent,
    ProjectAlarmsLocationAddListComponent,
    DataProcessingMeasureComponent,
    ManualFrComponent,
    ManualEnComponent,
    ButtonProjectEditComponent,
    DeviceBatchImportComponent,
    DeviceBatchImportCsvLoaderComponent,
    ProjectLastMeasureComponent,
    ProjectAlarmParametersComponent,
    AlarmParametersFormStaticAmplitudeComponent,
    DefaultViewContainerRefDirective,
    AlarmParametersFormStaticThresholdComponent,
    AlarmParametersFormCombinationAlarmComponent,
    CombinationAlarmExpressionElementComponent,
    InvalidValueErrorMessageComponent,
    VSensorComponent,
    VSensorLocationParamComponent,
    LocationAutocompleteInputComponent,
    UnitKeyModalComponent,
    GraphicalViewListComponent,
    DisableReactiveFormsDirective,
    DisableReactiveFormsDirective,
    ConvertLocationIdPipe,
    LocationAssignmentPreferencesToggleComponent,
    AdvancedDateSettingsComponent,
    ProjectsSubscriptionsComponent,
    SenceiveSubscriptionComponent,
    ExportCsvTaskComponent,
    JobTaskStatusPipe,
    ExportCsvTaskModalComponent,
    FileSizePipe,
    ButtonDownloadExportComponent,
    CsvSftpSubscriptionComponent,
    SmartOffsetsModeComponent,
    NewsteoSubscriptionComponent,
    DeviceTypeSelectorComponent,
    DragDropLocationsModalComponent,
    LocationTreeComponent,
    DragDropAlertModalComponent,
    WavesoftDeviceComponent,
    OffsetFormComponent,
    EraserFormComponent,
    DeviceFinderComponent,
    ThresholdFormComponent,
    WidgetProcessNamePipe,
    EventdynSubscriptionComponent,
    ParamChannelsExpeComponent,
    EventDynChartComponent,
    EventDynHeaderFiltersComponent,
    EventDynListTableComponent,
    ProjectMeasureGraphicEventDynComponent,
    ProjectsAlarmsValidatorComponent,
    ProjectLastAlarmsComponent,
    ProjectEdasAlarmsComponent,
    EdasAlarmsComponent,
    DashboardEdasComponent,
    DashboardEdasDetailComponent,
    ProjectNotationsComponent,
    NotationsModalComponent,
    ProjectLocationMapComponent,
    ProjectLocationPlanComponent,
    UploadPlanComponent,
    ProjectLocationMapPlanComponent,
    ProjectSubMenuComponent,
    ProjectViewListComponent,
    ProjectWimdComponent,
    WimdChartComponent,
    WimdTableComponent,
    WimdModalComponent
  ],
  imports: [
    AgmCoreModule.forRoot({
      apiKey: environment.googleMapsApiKey
    }),
    BrowserModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
    HttpClientModule,
    BrowserAnimationsModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    RouterModule.forRoot(
      appRoutes,
      {enableTracing: false, relativeLinkResolution: 'legacy'}
    ),
    NgbModule,
    FontAwesomeModule,
    MatProgressBarModule,
    MatSelectModule,
    MatOptionModule,
    MatCheckboxModule,
    MatFormFieldModule,
    MatInputModule,
    MatDividerModule,
    MatStepperModule,
    MatIconModule,
    MatMenuModule,
    MatListModule,
    MatChipsModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatCardModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatProgressSpinnerModule,
    MatBadgeModule,
    MatRadioModule,
    MatTooltipModule,
    MatSliderModule,
    MatTreeModule,
    MatGridListModule,
    MatDialogModule,
    MatTabsModule,
    MatProgressSpinnerModule,
    MatAutocompleteModule,
    MatDividerModule,
    ToastrModule.forRoot(),
    HighchartsChartModule,
    MatButtonToggleModule,
    MatButtonModule,
    DragDropModule,
    GridsterModule,
    ngfModule
  ],
  providers: [
    {provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: {useUtc: true}},
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
    {provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS},
    NgbActiveModal,
    GoogleMapsAPIWrapper,
    ClusterManager,
    CustomClusterManager,
    CustomGoogleMapsAPIWrapper,
    ProjectWimdComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
